module.exports = __webpack_public_path__ + "static/media/sticker.483ed550.png";